export const SET_RESOURCE_ACTION = 'SET_RESOURCE_ACTION'
export const SET_SUBPAGE = 'SET_SUBPAGE'
export const SET_MODULE_ID = 'SET_MODULE_ID'
export const SET_SEQUENCE_ID = 'SET_SEQUENCE_ID'

export function setResourceAction(crudAction) {
  return { type: SET_RESOURCE_ACTION, crudAction }
}

export function setModuleId(moduleId) {
  return { type: SET_MODULE_ID, moduleId }
}

export function setSequenceId(sequenceId) {
  return { type: SET_SEQUENCE_ID, sequenceId }
}

export function setSubpage(subpage) {
  return { type: SET_SUBPAGE, subpage: subpage }
}
